var dataStreamProfileStore = require('./data-stream-profile-store.js');
var streamCallbackManager = require('./stream-callback-manager.js');
var RequestFactory = require('./request/gateway-requests.js');
var UniqueIdGenerator = require('../utils/uuid-generator.js');
var TYPES = require('./type-ids.js');
var Guard = require('./guard.js');
var Errors = require('./smash-errors.js');
var RequestPatternType = require('./request-pattern-type.js');
var jsonpack = require('jsonpack/main');

import solaceWorkerInterface from '../solace/solaceWorkerInterface';

const publishTopics = {};

function Client(host, vpn, onException, onReconnected) {
  // private
  var params = {
    host: host || "http://52.71.3.123:80",
    user: 'DataClient',
    password: 'password',
    reconnectInterval: 3000,
    vpn: vpn || "TEST",
    onStreamingMessageReceived: onStreamingMessageReceived,
    onConnectionRecovered: onConnectionRecovered,
    onException: onException
  };

  if (typeof window === 'undefined') {
    // var transport = new TransportInterface(params);
  } else {
    var transport = new solaceWorkerInterface(params);
  }

  // track realtime dataset requests for recovery purpose
  var realtimeDatasets = {};
  var user = null;
  // Temporary solution for connection recovery.
  // After reconnect, try login again.
  var userCredential;
  var RequestType = {
    SAVE_STUDIO_MODEL: 'SAVE_STUDIO_MODEL',
    GET_STUDIO_MODEL: 'GET_STUDIO_MODEL',
    LogoutRequest: 'LogoutRequest'
  };

  function onStreamingMessageReceived(data) {
    streamCallbackManager.handle(data.dataset, data);
  }


  // once connection recovered, sends currently subscribed dataset request
  function onConnectionRecovered() {
    // Temporary solution for connection recovery.
    // var request = RequestFactory.LoginRequest(user.userId, userCredential);
    // transport.send(request, RequestPatternType.SINGLE, function () {
    //   requestExistingRealtimeDatasets();
    // });
    requestExistingRealtimeDatasets();
    onReconnected();
  }

  function connect(userId, password, onSuccessCb, onFailCb) {
    transport.connect(userId, password, onSuccessCb, onFailCb);
  }

  function requestExistingRealtimeDatasets() {
    for (var datasetId in realtimeDatasets) {
      var request = RequestFactory.SubscribeRealTimeData(datasetId);
      transport.send(request, RequestPatternType.STREAM);
    }
  }

  this.login = function (userId, password, callback) {
    if (!Guard.forNullOrEmpty(userId)) {
      throw new Errors.InvalidArgumentError("userId");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    // if (!transport.isConnected()) {
    //   connect(userId, password, onConnected, callback);
    // } else {
    //   onConnected();
    // }

    connect(userId, password, onConnected, callback);

    const callbackId = UniqueIdGenerator.get();

    function onConnected() {
      const getCurrentUserRequest = RequestFactory.GetCurrentUserRequest();
      transport.send(getCurrentUserRequest, RequestPatternType.SINGLE, onResponse, callbackId);
    }

    function onResponse(response) {
      if (response.typeId === TYPES.GetCurrentUserResponse && response.status === 0) {
        user = response.user;
        userCredential = password;
      } else {
        if (transport.isConnected()) {
          transport.disconnect();
        }
      }
      callback(response);
    }

    return callbackId;
  };

  this.logout = function (callback) {
    verifyUser();
    checkConnection();

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.LogoutRequest();
    transport.send(request, RequestPatternType.SINGLE, onUserLogoutResponse, callbackId);

    function onUserLogoutResponse(response) {
      if (response.typeId === TYPES.LogoutResponse) {
        user = null;
        realtimeDatasets = {};
        streamCallbackManager.destory();
        transport.disconnect();
      }
      if (callback) callback(response);
    }

    return callbackId;
  };

  this.registerRealtimeDataCallback = function (datasetId, callback) {
    checkConnection();
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }
    var callbackId = UniqueIdGenerator.get();
    streamCallbackManager.addTopicListener(datasetId, callback, callbackId);

    if (realtimeDatasets[datasetId] == null) {
      var request = RequestFactory.SubscribeRealTimeData(datasetId);
      transport.send(request, RequestPatternType.STREAM, callback, callbackId);
      realtimeDatasets[datasetId] = {};
    }

    return callbackId;
  };

  //========== SNAPSHOT DATA ==========

  this.getLatestData = function (datasetId, recordCount, callback) {

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("recordCount");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetLatestData(datasetId, recordCount);
    transport.send(request, RequestPatternType.REPLAY, callback, callbackId);

    return callbackId;
  };

  this.getDataAfterTime = function (datasetId, snapshotStartTime, noOfRecords, callback) {
    checkConnection();
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (!Guard.forISOString(snapshotStartTime)) {
      throw new Errors.InvalidArgumentError("snapshotStartTime");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetDataAfterTime(datasetId, snapshotStartTime, noOfRecords);
    transport.send(request, RequestPatternType.REPLAY, callback, callbackId);

    return callbackId;
  };

  this.getDataByRecordLocation = function (datasetId, fileBlockIndex, fileBlockRecordIndex,
                                           getDataByRecordLocationRequestType, noOfRecords, callback, cbId) {
    checkConnection();
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    var callbackId = cbId ? cbId : UniqueIdGenerator.get();
    var request = RequestFactory.GetDataByRecordLocation(datasetId, fileBlockIndex, fileBlockRecordIndex,
      getDataByRecordLocationRequestType, noOfRecords);
    transport.send(request, RequestPatternType.REPLAY, callback, callbackId);

    return callbackId;
  };

  this.getSnapshotDataByTime = function (datasetId, snapshotStartTime, snapshotEndTime, callback) {
    checkConnection();
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (!Guard.forISOString(snapshotStartTime)) {
      throw new Errors.InvalidArgumentError("snapshotStartTime");
    }

    if (!Guard.forISOString(snapshotEndTime)) {
      throw new Errors.InvalidArgumentError("snapshotEndTime");
    }

    if (new Date(snapshotStartTime) > new Date(snapshotEndTime)) {
      throw new Errors.InvalidArgumentError("snapshotEndTime");
    }

    if (!Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback");
    }

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetSnapshotDataByTimeRequest(datasetId, snapshotStartTime, snapshotEndTime);
    transport.send(request, RequestPatternType.REPLAY, callback, callbackId);

    return callbackId;
  };

  this.getDataForTimeRange = function (datasetId, snapshotStartTime, snapshotEndTime, noOfRecords, callback) {
    const callbackId = UniqueIdGenerator.get();
    const request = RequestFactory.GetDataForTimeRange(datasetId, snapshotStartTime, snapshotEndTime, noOfRecords);
    transport.send(request, RequestPatternType.REPLAY, callback, callbackId);

    return callbackId;
  };


  this.deregisterRealtimeDataCallback = function (callbackId) {
    checkConnection();
    verifyUser();

    if (!Guard.forNullOrEmpty(callbackId)) {
      throw new Errors.InvalidArgumentError("callbackId");
    }

    var datasetToStopUpdate = streamCallbackManager.removeTopicListener(callbackId);
    if (datasetToStopUpdate) {
      var request = RequestFactory.StopDataUpdateRequest(datasetToStopUpdate);
      transport.send(request, RequestPatternType.SINGLE, null, UniqueIdGenerator.get());
      delete realtimeDatasets[datasetToStopUpdate];
    }
  };

  this.saveDashboardState = function (previousDashboardState, currentDashboardState, callback, clientReferenceId) {
    currentDashboardState.dashboardState = jsonpack.pack(currentDashboardState.dashboardState);
    previousDashboardState.dashboardState = jsonpack.pack(previousDashboardState.dashboardState);
    var request = RequestFactory.UpdateDashboardStateRequest(previousDashboardState, currentDashboardState);
    transport.send(request, RequestPatternType.SINGLE, callback, clientReferenceId);
  };

  this.getDashboardState = function (dashboardId, callback) {
    var request = RequestFactory.GetDashboardStateByIdRequest(dashboardId);
    transport.send(request, RequestPatternType.QUERY, function (response) {

      if (response.data.length == 1) {
        var unpacked = "";
        if (response.data[0].dashboardState.substr(0, 2) === "No") {
          unpacked = JSON.stringify([]);
        } else {
          unpacked = JSON.stringify(jsonpack.unpack(response.data[0].dashboardState));
        }
        response.data[0].dashboardState = unpacked;
      }

      callback(response);
    });
  };

  this.getDashboards = function (callback, clientReferenceId) {
    const request = RequestFactory.GetDashboardsRequest(user.persistenceId);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getDashboardsById = function (userPersistenceId, callback, clientReferenceId) {
    const request = RequestFactory.GetDashboardsRequest(userPersistenceId);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getDashboardById = function (dashboardId, callback, clientReferenceId) {
    const request = RequestFactory.GetDashboardByIdRequest(dashboardId);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.addDashboard = function (dashboard, callback) {
    const request = RequestFactory.CreateDashboardRequest(dashboard.tabPosition, dashboard.title, user.persistenceId, dashboard.variables);
    // unavailable now
    // request["category"] = dashboard.category;

    var callbackId = UniqueIdGenerator.get();

    transport.send(request, RequestPatternType.SINGLE, function (response) {
      var dashboardCreated = response.currentPersistedData;
      response.clientRefId = callbackId;
      if (response.typeId === TYPES.UIDashboardCreated) {
        var compressedState = jsonpack.pack([]);
        var request2 = RequestFactory.CreateDashboardStateRequest(dashboardCreated.persistenceId, compressedState);
        transport.send(request2, RequestPatternType.SINGLE, function (response2) {
          response.currentPersistedData.dashboardStateId = response2.currentPersistedData.persistenceId;
          response.dashboardState = response2.currentPersistedData;
          callback(response);
        }, callbackId);
      } else {
        callback(response);
      }
    }, callbackId);

    return callbackId;
  };

  this.shareDashboard = function (userPersistenceId, dashboard, dashboardState, callback) {
    const createDashboardRequest = RequestFactory.CreateDashboardRequest(99, dashboard.title,
      userPersistenceId, JSON.stringify(dashboard.variables), dashboard.persistenceId, dashboard.originalDashboardUpdateTime);
    const callbackId = UniqueIdGenerator.get();

    transport.send(createDashboardRequest, RequestPatternType.SINGLE, response => {
      const dashboardCreated = response.currentPersistedData;
      response.clientRefId = callbackId;

      const compressedState = jsonpack.pack(dashboardState);
      const createDashboardStateRequest = RequestFactory.CreateDashboardStateRequest(dashboardCreated.persistenceId, compressedState);
      transport.send(createDashboardStateRequest, RequestPatternType.SINGLE, function (response2) {
        response.currentPersistedData.dashboardStateId = response2.currentPersistedData.persistenceId;
        response.dashboardState = response2.currentPersistedData;
        callback(response);
      }, callbackId);
    });

    return callbackId;
  };

  this.updateDashboard = function (previousDashboard, currentDashboard, callback) {
    var request = RequestFactory.UpdateDashboardRequest(previousDashboard, currentDashboard, currentDashboard.user);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.deleteDashboard = function (persistenceId, statePersistenceId, callback) {
    if (statePersistenceId != null) {
      var request = RequestFactory.RemoveUIDashboardStateRequest(persistenceId, statePersistenceId);
      transport.send(request, RequestPatternType.SINGLE, function (response) {

        var request2 = RequestFactory.RemoveDashboardRequest(persistenceId);
        transport.send(request2, RequestPatternType.SINGLE, callback);

      }, UniqueIdGenerator.get());
    } else {
      var request2 = RequestFactory.RemoveDashboardRequest(persistenceId);
      transport.send(request2, RequestPatternType.SINGLE, callback);
    }
  };

  this.deleteInvalidDashboard = function (persistenceId, callback) {
    var request = RequestFactory.RemoveDashboardRequest(persistenceId);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.getDataSetsByName = function (filter, callback, clientReferenceId) {
    var request = RequestFactory.GetDataSetsByNameRequest(filter.searchString, filter.pageNumber, filter.pageSize);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getOnlySubscribedDataSetsByName = function (filter, callback, clientReferenceId) {
    var request = RequestFactory.FindByNameOrDescriptionSubscribedByUserRequest(user.persistenceId, filter.searchString, filter.pageNumber, filter.pageSize);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getOnlyUnsubscribedDataSetsByName = function (filter, callback, clientReferenceId) {
    var request = RequestFactory.FindByNameOrDescriptionUnsubscribedByUserRequest(user.persistenceId, user.organization, filter.searchString, filter.pageNumber, filter.pageSize);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getMarketPlaceDataSetsByName = function (filter, callback, clientReferenceId) {
    var request = RequestFactory.GetMarketplaceDatasetsByNameRequest(filter.searchString, '1f852342-bfab-11e5-8232-0a900cdd7aeb', user.persistenceId, filter.pageNumber, filter.pageSize);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getDataBankDatasetByNameOrDescription = function (filter, callback, clientReferenceId) {
    var request;
    if (user.organization) {
      request = RequestFactory.GetDataBankDatasetByNameOrDescriptionForUserOrOrg(filter.searchString, user.organization, user.persistenceId, filter.pageNumber, filter.pageSize);
    } else {
      request = RequestFactory.GetDataBankDatasetByNameOrDescription(filter.searchString, user.persistenceId, filter.pageNumber, filter.pageSize);
    }
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.getDataSetById = function (dataSetId, callback, clientReferenceId) {
    var request = RequestFactory.GetDataSetByIdRequest(dataSetId);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.GetDatasetByIdWithUsersCreated = function (dataSetId, callback, clientReferenceId) {
    var request = RequestFactory.GetDatasetByIdWithUsersCreated(dataSetId, user.persistenceId);
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };


  this.getDataProfileById = function (dataProfileId, callback, clientReferenceId) {
    var callbackId = UniqueIdGenerator.get();
    if (dataStreamProfileStore.doesProfileExist(dataProfileId)) {
      var dataProfile = dataStreamProfileStore.get(dataProfileId);
      callback({
        clientRefId: clientReferenceId,
        data: [dataProfile]
      });
    } else {
      var request = RequestFactory.GetDataProfileRequest(dataProfileId);
      transport.send(request, RequestPatternType.QUERY, function (response) {
        // store and invoke callback
        if (response.data.length === 1) {
          // temporary added timestamp field
          const timestampField = {
            name: "timestamp",
            fieldId: "timestamp",
            valueType: 6
          };

          let fieldIndexForTimestamp = response.data[0].fields.findIndex(f => f.name == null);
          if (fieldIndexForTimestamp == -1) {
            response.data[0].fields.push(timestampField);
          } else {
            response.data[0].fields[fieldIndexForTimestamp] = timestampField;
          }

          dataStreamProfileStore.store({
            persistenceId: response.data[0].persistenceId,
            name: response.data[0].name,
            fields: response.data[0].fields,
            description: response.data[0].description,
            createdByOrganization: response.data[0].createdByOrganization,
            createdByUser: response.data[0].createdByUser,
            createDatasetEventTypeId: response.data[0].createDatasetEventTypeId,
            replayDatasetEventTypeId: response.data[0].replayDatasetEventTypeId
          });
        } else {
          response.data = [];
        }
        callback(response);
      }, callbackId);
    }

  };

  this.getAllDataProfile = function (callback, clientReferenceId) {
    var request = RequestFactory.GetAllDataProfilesRequest();
    transport.send(request, RequestPatternType.QUERY, callback, clientReferenceId);
  };

  this.saveStudioModel = function (id, studioType, model) {
    var request = {};
    request.typeName = RequestType.SAVE_STUDIO_MODEL;
    request.id = id;
    request.studioType = studioType;
    request.model = model;
    request.typeId = UniqueIdGenerator.get();
    transport.send(request, RequestPatternType.SINGLE);
  };

  this.getStudioModel = function (id, studioType, callback, clientReferenceId) {
    callback({data: []});
  };

  this.createUser = function (data, callback, clientReferenceId) {   // Create a user and connect to the gateway
    var tUser = 'DataClient';
    var tpass = 'password';
    if (!transport.isConnected()) {
      connect(tUser, tpass, onConnected);
    } else {
      onConnected();
    }

    function onConnected() { //s
      var request = RequestFactory.RegisterUserRequest(data.userId,
        data.password,
        data.firstName,
        data.lastName,
        data.email);

      transport.send(request, RequestPatternType.SINGLE, callback, clientReferenceId);
    }
  };

  this.updateUser = function (previousUser, currentUser, callback) {
    var request = RequestFactory.UpdateUserRequest(previousUser, currentUser);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.updateUserCredential = function (oldPassword, newPassword, callback) {
    var request = RequestFactory.UpdateUserCredentialRequest(oldPassword, newPassword, user.userId);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.createDataset = function (dataset, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.CreateDataset(dataset);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  };

  this.searchUserByUserId = function (userId, callback) {
    var request = RequestFactory.SearchUserByUserIdRequest(userId);
    transport.send(request, RequestPatternType.QUERY, callback);
  };

  this.createDataProfile = function (dataProfile, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.CreateDataProfile(dataProfile);
    dataProfile.createdByUser = user.persistenceId;
    dataProfile.createdByOrganization = user.organization || null;
    dataProfile.createDatasetEventTypeId = UniqueIdGenerator.get();
    dataProfile.replayDatasetEventTypeId = UniqueIdGenerator.get();
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  };

  this.createDatasetLicense = function (license, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.CreateDatasetLicense(license);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  }


  this.subscribeDataset = function (datasetId, datasetLicenseId, callback) {
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (callback && !Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback")
    }

    let callbackId = UniqueIdGenerator.get();
    let request = RequestFactory.SubscribeDatasetRequest(user.persistenceId, datasetId, datasetLicenseId);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  };

  this.unsubscribeDataset = function (datasetId, datasetLicenseId, callback, clientReferenceId) {
    verifyUser();

    if (!Guard.forNullOrEmpty(datasetId)) {
      throw new Errors.InvalidArgumentError("datasetId");
    }

    if (callback && !Guard.forFunction(callback)) {
      throw new Errors.InvalidArgumentError("callback")
    }

    let callbackId = UniqueIdGenerator.get();
    let request = RequestFactory.UnSubscribeDatasetRequest(user.persistenceId, datasetId, datasetLicenseId);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId, clientReferenceId);

    return callbackId;
  };

  this.checkUserDatasetSubscription = function (datasetId, callback) {
    verifyUser();

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.CheckUserDatasetSubscription(user.persistenceId, datasetId);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.GetAccessAuditInDaysByUser = function (start, end, callback) {

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetAccessAuditInDaysByUserRequest(user.persistenceId, start, end);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.GetAccessAuditInMonthsByUser = function (start, end, callback) {

    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetAccessAuditInMonthsByUserRequest(user.persistenceId, start, end);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.GetDatasetLicenses = function (datasetId, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.FindDatasetLicenseRequest(datasetId);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };


  this.createAnalyticStudio = function (name, description, createdByOrganization, userId,
                                        categories, state, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.CreateAnalyticStudio(name, description, createdByOrganization, userId,
      categories, state);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  };

  this.findAnalyticStudioByNameOrDescription = function (filter, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.FindAnalyticStudioByNameOrDescriptionRequest(
      filter.searchString, filter.pageNumber, filter.pageSize);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.createUserDatasetWidget = function (datasetId, widgetState, callback) {
    var request = RequestFactory.CreateUserDatasetWidget(user.persistenceId, datasetId, widgetState);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.updateUserDatasetWidget = function (previousDashboard, currentDashboard, callback) {
    var request = RequestFactory.UpdateUserDatasetWidget(user.persistenceId, previousDashboard, currentDashboard);
    transport.send(request, RequestPatternType.SINGLE, callback);
  };

  this.findDatasetWidgetsByUser = function (dataset, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.FindDatasetWidgetsByUserRequest(user.persistenceId, dataset);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.findDefaultWidget = function (dataprofile, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.FindDatasetWidgetByProfile(dataprofile);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  };

  this.publishDataRequest = function (datasetId, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.PublishDataRequest(datasetId);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);
    return callbackId;
  };

  this.publishData = function (datasetId, dataProfileName, createDatasetEventTypeId, data, callback) {

    if (publishTopics[datasetId] == null) {
      this.publishDataRequest(datasetId, function (response) {
        publishTopics[datasetId] = response.publishTopic;
        publish();
      });
    } else {
      publish();
    }

    function publish() {
      var callbackId = UniqueIdGenerator.get();
      var request = RequestFactory.PublishData(datasetId, dataProfileName, createDatasetEventTypeId, data);
      transport.send(request, RequestPatternType.SINGLE, callback, callbackId, publishTopics[datasetId]);
      return callbackId;
    }
  };


  this.serverSideFunctionRequest = function (requestId, callback, functionName, parameters) {
    let request;
    const params = [...parameters];
    switch (functionName) {
      case "TSCalculateGroupBy": {
        params.splice(9, 1);  // remove groupByTimeUnit
        request = RequestFactory.TSCalculate(...params);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "TSCalculate" : {
        request = RequestFactory.TSCalculate(...params);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "TSCalculateFilterByString" : {
        request = RequestFactory.TSCalculateFilterByString(...params);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "TSCalculateMinMaxAvgMedian" : {
        request = RequestFactory.TSCalculateMinMaxAvgMedian(...params);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "Latest" : {
        // Latest("datasetId||fieldId") or Latest(datasetId, fieldId)
        const datasetId = params.length === 1 ? params[0].split("||")[0] : params[0];
        request = RequestFactory.GetLatestData(datasetId, 1);

        transport.send(request, RequestPatternType.REPLAY, response => {
          if (response.typeId !== TYPES.GetLatestDataResponse) {
            callback(response);
          }
        }, requestId);
        break;
      }
      case "GetDatasetDoubleFieldByTimeRange" : {
        request = RequestFactory.GetDataForTimeRange(params[0], params[2], params[3], params[4]);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "GetDataAfterTimeForResolution":
      case "GetDataAfterTime" : {
        // GetDataAfterTime(datasetId, fieldId, snapshotStartTime, noRecords)
        request = RequestFactory.GetDataAfterTime(params[0], params[2], params[3]);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "GetDataForTimeRange" : {
        request = RequestFactory.GetDataForTimeRange(params[0], params[2], params[3], -1);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "GetDataBeforeTime": {
        this.getDataBeforeTime(params[0], params[2], params[3], requestId, callback);
        break;
      }
      case "CanDealGoldReportRequest": {
        request = RequestFactory.CanDealGoldReportRequest(params[0], params[1], params[2], params[3], params[4]);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
      case "GetDataByRecordLocation": {
        request = RequestFactory.GetDataByRecordLocation(params[0], params[2], params[3], params[4], params[5]);
        transport.send(request, RequestPatternType.REPLAY, callback, requestId);
        break;
      }
    }
  };

  this.getDataBeforeTime = function (datasetId, snapshotStartTime, noRecords = 1, requestId, callback) {
    if (!isNumeric(noRecords)) {
      noRecords = 1;
    }

    getAfterTimeData(datasetId, snapshotStartTime)
      .then(res => {
        if (res.responseIndex === -1) {
          callback(res);
        } else {
          const eventId = res.eventId.replace(/-/g, "");
          const fileBlockIndex = parseInt("0x" + eventId.substr(0, 16));
          const fileBlockRecordIndex = parseInt("0x" + eventId.substr(16, 32));
          this.getDataByRecordLocation(datasetId, fileBlockIndex, fileBlockRecordIndex, 1, noRecords, (response) => {
            callback(response);
          }, requestId);
        }
      });

    function getAfterTimeData(datasetId, snapshotStartTime) {
      const startTime = new Date(snapshotStartTime).getTime();
      if (startTime > Date.now()) {
        return new Promise(resolve => {
          transport.send(RequestFactory.GetLatestData(datasetId, 1), RequestPatternType.REPLAY, (res) => {
            resolve(res);
          });
        });
      } else {
        return new Promise(resolve => {
          transport.send(RequestFactory.GetDataAfterTime(datasetId, snapshotStartTime, 1), RequestPatternType.REPLAY, (res) => {
            if (res.responseIndex === -1) {
              transport.send(RequestFactory.GetLatestData(datasetId, 1), RequestPatternType.REPLAY, (res2) => {
                resolve(res2);
              });
            } else {
              resolve(res);
            }
          });
        })
      }
    }
  };

  this.isConnected = function () {
    return transport.isConnected();
  };

  this.unpack = function (packedJson) {
    return jsonpack.unpack(packedJson);
  };

  this.parseEventId = function (eventId) {
    eventId = eventId.replace(/-/g, "");
    let fileBlockIndex = parseInt("0x" + eventId.substr(0, 16));
    let fileBlockRecordIndex = parseInt("0x" + eventId.substr(16, 32));
    return {
      fileBlockIndex: fileBlockIndex,
      fileBlockRecordIndex: fileBlockRecordIndex
    }
  };

  this.getApiKeys = function(callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.GetApiKeys(user.persistenceId);
    transport.send(request, RequestPatternType.QUERY, callback, callbackId);

    return callbackId;
  }

  this.deleteApiKey = function(apiKey, callback) {
    var callbackId = UniqueIdGenerator.get();
    var request = RequestFactory.DeleteApiKey(apiKey);
    transport.send(request, RequestPatternType.SINGLE, callback, callbackId);

    return callbackId;
  }

  function verifyUser() {
    if (user === null) {
      throw new Errors.UserNotLoggedInError();
    }
  }

  function checkConnection() {
    if (!transport.isConnected()) {
      throw new Errors.ConnectionError();
    }
    return true;
  }
}

module.exports = Client;


// WEBPACK FOOTER //
// ./src-client-lib/api/smash-client.js